import { atom } from "jotai";

export const stepAtom = atom(0);
export const subscriptionAtom = atom({});
export const cancelReasonAtom = atom("");
export const isFinishedAtom = atom(false);
export const isLoadingAtom = atom(false);
